import React from 'react'
import Resx from '@/components/Resx'
import { DatePicker } from '@/components/DatePicker'
import {
  FormGroup,
  Label
} from 'reactstrap'

export default class DateValidInputs extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      validFrom: props.validFrom,
      validTo: props.validTo
    }
  }

  onChange () {
    this.props.onChange({
      validFrom: this.state.validFrom,
      validTo: this.state.validTo
    })
  }

  changeValidFrom = (value) => {
    this.setState({ validFrom: (value ? value.utc() : value) },
      () => this.onChange())
  }

  changeValidTo = (value) => {
    this.setState({ validTo: (value ? value.utc() : value) },
      () => this.onChange())
  }

  render () {
    const { isReadOnly } = this.props

    return (
      <React.Fragment>
        <FormGroup>
          <Label><Resx name='Common.ValidFrom' />:</Label>
          <DatePicker
            value={this.state.validFrom}
            onChange={(value) => this.changeValidFrom(value)}
            disabled={isReadOnly} />
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Common.ValidTo' />:</Label>
          <DatePicker
            value={this.state.validTo}
            onChange={(value) => this.changeValidTo(value)}
            disabled={isReadOnly} />
        </FormGroup>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/codeLists/dateValidInputs.js